import { configureStore } from "@reduxjs/toolkit";
import commonReducer from "./commonSlice";
import userSlice from "./usersSlice";
import homeScreenFilterSlice from "./homeScreenFilter";
import alertsSlice from "./alertsSlice";
import recordFiltersSlice from "./recordFilters";
import dimeAiWidgetSlice from "./dimeAiWidgetSlice";

export const store = configureStore({
  reducer: {
    common: commonReducer,
    user: userSlice,
    homeScreenFilter: homeScreenFilterSlice,
    alerts: alertsSlice,
    recordFilters: recordFiltersSlice,
    dimeAiWidget: dimeAiWidgetSlice,
  },
});

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;
